import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ImmigrationDetailsState } from './immigrationDetails.state';
export const getImmigrationDetailsState = createFeatureSelector<ImmigrationDetailsState>('immigrationDetails');
export const getImmigrationDetails = createSelector(
  getImmigrationDetailsState,
  (state) => state.immigrationDetails
);

